import 'css-chunk:src/app/containers/Home/RolesView/RolesView.scss';export default {
  "RolesView": "_RolesView_ax1c3_2",
  "table": "_table_ax1c3_2",
  "nameCell": "_nameCell_ax1c3_2",
  "avatar": "_avatar_ax1c3_2"
};